export const statusTypes = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  SIGNATURE_PENDING: 'SIGNATURE_PENDING',
  CLOSED: 'CLOSED',
  CANCELED: 'CANCELED',
};
